export class Requirement {
  id: number;
  idProduct: number; // włókno | para miedziana
  idOperator?: number; // może być globalne
  idBuilding?: number; // może być globalne bez wybranego budynku.
  idProductRequred?: number;
  description: string;
}
